import {lazyRegister} from '@/Core/lazyRegister';
import './sidebar-item.component.css';
import template from './sidebar-item.component.html';
import {SideBarMenuItem} from "./SideBarMenuItem";
import {createRandomId} from "@core/global";

class SidebarItemController {
    static $inject = ['$element'];

    public selectedItemId: string;
    public item: SideBarMenuItem;
    public isExpanded: boolean = true;
    public onClick: Function;

    constructor(private $element) {
    }

    $onInit(): void {
        this.$element.addClass('sidebar-item');
        this.item = this.item || {} as SideBarMenuItem;

        // create random id if not exist
        if (!this.item.id) {
            this.item.id = 'sidebar-item-' + createRandomId();
        }
        
        if (this.item.children && this.item.children.length > 0) {
            this.isExpanded = true;
        }
    }

    handleSelect() {
        if (this.item.children && this.item.children.length > 0) {
            this.isExpanded = !this.isExpanded;
            return;
        }

        this.selectedItemId = this.item.id;
        console.debug('handleSelect', this.selectedItemId)
        
        if (typeof this.item.onSelect == "function")
            this.item.onSelect();

        if (this.onClick) {
            this.onClick({$tab: this.item.id});
        }
    }

    handleAccept() {
        if (typeof this.item.onAccept == "function")
            this.item.onAccept();
    }

    handleChildClick($tab) {
        if (this.onClick) {
            this.onClick({$tab: $tab});
        }
    }
}

export const SidebarItemComponent: ng.IComponentOptions = {
    bindings: {
        selectedItemId: '=',
        item: '<',
        onClick: '&?'
    },
    template: template,
    controller: SidebarItemController
};

lazyRegister.component('sidebarItem', SidebarItemComponent);